import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerNoteForm from '../containers/PlannerNoteFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerNoteEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerNoteEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_note_route_edit')} />
          <PlannerNoteForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerNoteEditScreen;

Logger.log('silly', `PlannerNoteEditScreen loaded.`);